import React, { Component } from 'react'
import UserRow from '../Users/UserRow.js'
import TitleBar from '../TitleBar/index.js'
import getLabel from '../../utilities/label.js'
import { Link } from 'react-router-dom'
import './notes.css'
import _ from 'lodash'

export default class Notes extends Component {
  constructor(props) {
    super(props)
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const emailNoteButton = '<i class=\'fa fa-paper-plane-o\' aria-hidden=\'true\'></i>'
    this.props.setActiveTab('homepage')
    this.state = {
      backButton: backButton,
      refreshButton: refreshButton,
      emailNoteButton: emailNoteButton
    }
    this.refresh = this.refresh.bind(this)
    window.trackPage('NotesScreen')
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'users',
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
    this.props.updateResource({
      key: 'sessions',
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
    this.props.updateResource({
      key: 'sponsors',
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  getUserNotes() {
  	var users = []
  	_.each(this.props.users.event_users, (user) => {
  		if(user.note_on_user) {
  			users.push(user)
  		}
  	})
    if(users.length > 0) {
      var elements = [<div className='gray-header' key='notes_header'>{getLabel({key: 'user', plural: true})}</div>]
  		_.each(users, function(user){
  			elements.push(
  				<div className='user-note-row' key={user.id} >
            <Link
              to={{
                pathname: '/user/' + user.id,
                props: {isTakingNotes: true},
                activeTab: 'homepage'
              }}
            >
              <UserRow
                user={user}
                skipGB={true}
                isTakingNotes={true}
                isNoteIndex={true}
              />
            </Link>
            <div className="chevron">
              <i className='fa fa-angle-right'></i>
            </div>
            <hr />
          </div>
        )
      })
      return(<div>{elements}</div>)
    } else { return 0 }
  }

  getSessionNotes() {
  	var sessions = []
  	_.each(this.props.sessions.sessions, (session) => {
  		if(session.note_on_session) {
  			sessions.push(session)
  		}
  	})
    if(sessions.length > 0) {
      var elements = [<div className='gray-header' key='session_notes_header'>{getLabel({key: 'session', plural: true})}</div>]
  		_.each(sessions, function(session){
  			elements.push(
  				<div key={session.name} className='session-note-row'>
            <div className='session-note-row'>
              <Link
                to={{
                  pathname: '/session/' + session.id,
                  state: {isTakingNotes: true}
                }}
              >
                <div className="note-image"><i className="fa fa-calendar fa-3x" aria-hidden="true"></i></div>
                <div className="session-name">{session.name}</div>
                <div className='note'>{session.note_on_session}</div>
              </Link>
            </div>
            <div className="chevron">
              <i className='fa fa-angle-right'></i>
            </div>
            <hr />
          </div>
        )
      })
      return(<div>{elements}</div>)
    } else { return 0 }
  }

  getSponsorNotes() {
  	var sponsors = []
  	_.each(this.props.sponsors.sponsors, (sponsor) => {
  		if(sponsor.note_on_sponsor) {
  			sponsors.push(sponsor)
  		}
  	})
    if(sponsors.length > 0) {
      var elements = [<div className='gray-header' key="sponsor_notes_header">{getLabel({key: 'sponsor', plural: true})}</div>]
  		_.each(sponsors, function(sponsor){
  			elements.push(
  				<div key={sponsor.id} className='sponsor-note-row'>
  					<Link to={{
              pathname: '/sponsor/' + sponsor.id,
              state: {isTakingNotes: true}
            }}
            >
              <div className='note-image'><img width='50' src={sponsor.logo} alt=''/></div>
              <div className="sponsor-name">{sponsor.name}</div>
              <div className='note'>{sponsor.note_on_sponsor}</div>
  					</Link>
            <div className="chevron">
              <i className='fa fa-angle-right'></i>
            </div>
            <hr />
  				</div>
        )
  		})
  	  return(<div>{elements}</div>)
    } else { return 0 }
  }

  formatNotes() {
    var userNotes = ''
    var sessionNotes = ''
    var sponsorNotes = ''
    _.each(this.props.users.event_users, (user) => {
      if(user.note_on_user) {
        userNotes += (user.first_name + ' ' + user.last_name).toUpperCase() + '%0A'
        userNotes += encodeURI(user.note_on_user) + '%0A%0A'
      }
    })
    if(userNotes.length > 0) {
      userNotes = (getLabel('user') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + userNotes
    }
    _.each(this.props.sessions.sessions, (session) => {
      if(session.note_on_session) {
        sessionNotes += session.name.toUpperCase() + '%0A'
        sessionNotes += encodeURI(session.note_on_session) + '%0A%0A'
      }
    })
    if(sessionNotes.length > 0) {
      sessionNotes = (getLabel('session') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + sessionNotes
    }
    _.each(this.props.sponsors.sponsors, (sponsor) => {
      if(sponsor.note_on_sponsor) {
        sponsorNotes += sponsor.name.toUpperCase() + '%0A'
        sponsorNotes += encodeURI(sponsor.note_on_sponsor) + '%0A%0A'
      }
    })
    if(sponsorNotes.length > 0) {
      sponsorNotes = (getLabel('sponsor') + ' ' + getLabel({ key: 'note', plural: true })).toUpperCase() + '%0A%0A' + sponsorNotes
    }
    return userNotes + '%0A' + sessionNotes  + '%0A' + sponsorNotes
  }

  emailNotes() {
    var notesBody = this.formatNotes()
    var subject = getLabel({ key: 'note', plural: true }) + ': ' + window.currentUser.current_event_name
    return 'mailto: ?subject=' + subject+ '&body=' + notesBody
  }

  render() {
    var userNotes = this.getUserNotes() === 0 ? '' : this.getUserNotes()
    var sessionNotes = this.getSessionNotes() === 0 ? '' : this.getSessionNotes()
    var sponsorNotes = this.getSponsorNotes() === 0 ? '' : this.getSponsorNotes()
    var noNotes = (userNotes === '') && (sessionNotes === '') && (sponsorNotes === '') ? '' : 'hide'
    return (
      <div className='notes-page'>
        <TitleBar
          title={ getLabel({key: 'note', plural: true}) }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh }
          emailNoteButtonLabel={ this.state.emailNoteButton }
          emailNoteButtonAction={ this.emailNotes() } />
        <br/>
        {userNotes}
        {sessionNotes}
        {sponsorNotes}
        <p className={'noResults '+ noNotes}>{getLabel('no_results_found')}</p>
      </div>
    )
  }
}
